import React from 'react';
import './main.css';
import Menu from './Menu';
import Screens from './Screens';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

export default
class Content extends React.Component {
	render(){
		return (
			<div className="content">
				<div className="menu-wrap">
					<Menu />
				</div>
				<div className="content-wrap">
					<Route render={({ location }) => (
						<TransitionGroup>
							<CSSTransition key={location.key} classNames="fade" timeout={300}>
								<Switch location={location}>
									<Route path="/" exact component={Screens.MainScreen} />
									<Route path="/kontakt" exact component={Screens.KontaktScreen} />
									<Route path="/wspolpraca" exact component={Screens.WspolpracaScreen} />
									<Route path="*" component={Screens.NotFoundScreen} />
								</Switch>
							</CSSTransition>
						</TransitionGroup>
					)} />
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Content/index.js